var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 3.33L8.17016 6.5L9.58016 5.09L5.00016 0.5L0.410156 5.09L1.83016 6.5L5.00016 3.33ZM5.00016 15.67L1.83016 12.5L0.420156 13.91L5.00016 18.5L9.59016 13.91L8.17016 12.5L5.00016 15.67Z",
    fill: "#91278F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.8243f6cb1e106b0125d4e74f49e1568f.svg";
export { ForwardRef as ReactComponent };